var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 17C10.224 17 10 16.776 10 16.5C10 15.121 8.878 14 7.5 14C6.122 14 5 15.121 5 16.5C5 16.776 4.776 17 4.5 17C4.224 17 4 16.776 4 16.5C4 14.57 5.57 13 7.5 13C9.43 13 11 14.57 11 16.5C11 16.776 10.776 17 10.5 17ZM10 9.5C10 8.122 8.878 7 7.5 7C6.122 7 5 8.122 5 9.5C5 10.878 6.122 12 7.5 12C8.878 12 10 10.878 10 9.5ZM9 9.5C9 10.327 8.327 11 7.5 11C6.673 11 6 10.327 6 9.5C6 8.673 6.673 8 7.5 8C8.327 8 9 8.673 9 9.5ZM24 17.5V6.5C24 4.019 21.981 2 19.5 2H4.5C2.019 2 0 4.019 0 6.5V17.5C0 19.981 2.019 22 4.5 22H19.5C21.981 22 24 19.981 24 17.5ZM19.5 3C21.43 3 23 4.57 23 6.5V17.5C23 19.43 21.43 21 19.5 21H4.5C2.57 21 1 19.43 1 17.5V6.5C1 4.57 2.57 3 4.5 3H19.5ZM20 8.5C20 8.224 19.776 8 19.5 8H13.5C13.224 8 13 8.224 13 8.5C13 8.776 13.224 9 13.5 9H19.5C19.776 9 20 8.776 20 8.5ZM20 12.5C20 12.224 19.776 12 19.5 12H13.5C13.224 12 13 12.224 13 12.5C13 12.776 13.224 13 13.5 13H19.5C19.776 13 20 12.776 20 12.5ZM18 16.5C18 16.224 17.776 16 17.5 16H13.5C13.224 16 13 16.224 13 16.5C13 16.776 13.224 17 13.5 17H17.5C17.776 17 18 16.776 18 16.5Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdCard);
export default __webpack_public_path__ + "static/media/id-card.c3b7e6be68bd5d39979ad196ee584910.svg";
export { ForwardRef as ReactComponent };